'use client'
/* eslint-disable */
// @ts-nocheck
import { PopoverClose } from '@radix-ui/react-popover'
import { Link2Icon, Trash2, X } from 'lucide-react'
import { useTranslations } from 'next-intl'

import React, { type FormEvent } from 'react'

import { Button, type ButtonProps } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip'
import { cn } from '@/utils'

import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover'
import { useToolbar } from './toolbar-provider'
import { getUrlFromString } from '../tiptap-utils'

const LinkToolbar = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const { editor } = useToolbar()
    const t = useTranslations('components.tiptap.toolbars.link')
    const [link, setLink] = React.useState('')

    const handleSubmit = (e: FormEvent) => {
      e.preventDefault()
      e.stopPropagation()
      const url = getUrlFromString(link)
      url && editor?.chain().focus().setLink({ href: url }).run()
    }

    React.useEffect(() => {
      setLink(editor?.getAttributes('link').href ?? '')
    }, [editor])

    return (
      <Popover>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger
              disabled={!editor?.can().chain().setLink({ href: '' }).run()}
              asChild
            >
              <Button
                variant="ghost"
                size="sm"
                type="button"
                className={cn(
                  'h-8 w-max px-3 font-normal',
                  editor?.isActive('link') && 'bg-accent',
                  className
                )}
                ref={ref}
                {...props}
              >
                <Link2Icon />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <span>{t('label')}</span>
          </TooltipContent>
        </Tooltip>

        <PopoverContent
          onCloseAutoFocus={(e) => {
            e.preventDefault()
          }}
          asChild
          className="relative px-3 py-2.5"
        >
          <div className="relative">
            <PopoverClose className="absolute top-3 right-3">
              <X className="h-4 w-4" />
            </PopoverClose>
            <form onSubmit={handleSubmit}>
              <Label>{t('label')}</Label>
              <p className="text-gray-11 text-sm">{t('description')}</p>
              <div className="mt-3 flex flex-col items-end justify-end gap-3">
                <Input
                  value={link}
                  onChange={(e) => {
                    setLink(e.target.value)
                  }}
                  className="w-full"
                  placeholder={t('placeholder')}
                />
                <div className="flex items-center gap-3">
                  {editor?.getAttributes('link').href && (
                    <Button
                      type="reset"
                      size="sm"
                      className="text-gray-11 h-8"
                      variant="ghost"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        editor?.chain().focus().unsetLink().run()
                        setLink('')
                      }}
                    >
                      <Trash2 className="mr-2 h-4 w-4" />
                      {t('remove')}
                    </Button>
                  )}
                  <Button size="sm" className="h-8">
                    {editor?.getAttributes('link').href
                      ? t('update')
                      : t('confirm')}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </PopoverContent>
      </Popover>
    )
  }
)

LinkToolbar.displayName = 'LinkToolbar'

export { LinkToolbar }
